// extracted by mini-css-extract-plugin
export default {"articleTitle":"certificateFlow_articleTitle__DZI70","pictureContainer":"certificateFlow_pictureContainer__WVC1B"};